import { CallbackSet } from 'scripts/engine/helpers';

class ChangeHistory {
    static MAX_STATE_STACK = 50;
    _undoStack: string[];
    _redoStack: string[];
    onUndoRedoChange: CallbackSet;

    constructor() {
        this._undoStack = [];
        this._redoStack = [];
        this.onUndoRedoChange = new CallbackSet();
    }

    addUndo(data: string) {
        if (data === this._undoStack.at(-1)) return;
        if (this._undoStack.length > ChangeHistory.MAX_STATE_STACK) {
            this._undoStack.shift();
        }
        this._undoStack.push(data);
    }

    removeUndo(): string | null {
        if (this._undoStack.length > 0) {
            const undo = this._undoStack.pop()!;
            this.emitUndoRedoChangeEvent();
            return undo;
        }
        return null;
    }

    clearUndos() {
        this._undoStack = [];
        this.emitUndoRedoChangeEvent();
    }

    addRedo(data: string) {
        if (data === this._redoStack.at(-1)) return;
        if (this._redoStack.length > ChangeHistory.MAX_STATE_STACK) {
            this._redoStack.shift();
        }
        this._redoStack.push(data);
        this.emitUndoRedoChangeEvent();
    }

    removeRedo(): string | null {
        if (this._redoStack.length > 0) {
            const redo = this._redoStack.pop()!;
            this.emitUndoRedoChangeEvent();
            return redo;
        }
        return null;
    }

    clearRedos() {
        this._redoStack = [];
        this.emitUndoRedoChangeEvent();
    }

    undo(callback: (data: string) => void, redoState: string | null) {
        const undo = this.removeUndo();
        if (undo != null) {
            if (redoState != null) {
                this.addRedo(redoState);
            }
            callback?.(undo);
        }
        this.emitUndoRedoChangeEvent();
    }

    redo(callback: (data: string) => void, undoState: string | null) {
        const redo = this.removeRedo();
        if (redo != null) {
            if (undoState != null) {
                this.addUndo(undoState);
            }
            callback?.(redo);
        }
        this.emitUndoRedoChangeEvent();
    }

    clearHistory() {
        this._undoStack = [];
        this._redoStack = [];
        this.emitUndoRedoChangeEvent();
    }

    emitUndoRedoChangeEvent() {
        this.onUndoRedoChange.call(this._undoStack.length, this._redoStack.length);
    }
}

export default ChangeHistory;
